import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { LoadingButton } from "../Utils/CustomComponent";
import FormBox from "../components/FormBox/FormBox";
import axios from "../axios";
import urls from "../Utils/urls";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { borrowerFormSchema } from "../Utils/formOptions";
import slsLogo from "../assets/images/loanlinq.png";

const BorrowerEnrollmentForm = () => {
  const [afterSubmit, setAfterSubmit] = useState(false);
  const navigate = useNavigate();
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm(borrowerFormSchema);

  const onSubmit = async (data) => {
    const res = await axios.post(
      urls.borrower.postValidateBorrowerEnrollment,
      {
        user: data.user,
        enrollment_number: data.enrollment_number,
        password: data.confirm_password,
      },
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Basic UkVTVEFQSUxPQU5MSU5ROjg4V2VIZWxwVSQjQA==`,
        },
      }
    );
    if (res) {
      if (res?.data?.error) {
        toast.error(`Borrower Enrolled Unsuccesfull ${res.data.error}`);
      } else {
        toast.success(`Borrower Enrolled successfully`);
        setTimeout(() => {
          navigate("login");
        }, 5000);
      }
    }
  };

  return (
    <div className="d-flex flex-column ">
      <div
        style={{ height: "80vh", width: "100%" }}
        className="d-flex align-items-center justify-content-center container-fluid"
      >
        <div style={{ position: "relative", width: "500px" }}>
          <img src={slsLogo} style={{ width: "385px" }} alt="logo" />
          <h3>Borrower Enrollment Form</h3>
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="mt-5 text-start">
              <FormBox
                options={borrowerEnrollmentFormArr}
                register={register}
                watch={watch}
                setValue={setValue}
                errors={errors}
              />
              <div className="col-sm-12 d-flex justify-content-between">
                <LoadingButton
                  className="me-2"
                  type="submit"
                  title={"Submit"}
                  disabled={afterSubmit}
                  loading={afterSubmit}
                />
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default BorrowerEnrollmentForm;

const borrowerEnrollmentFormArr = [
  {
    title: "Email ID",
    field: "user",
    type: "text",
    className: "col-12",
  },
  {
    title: "Enrollment Code",
    field: "enrollment_number",
    type: "text",
    className: "col-12",
  },
  {
    title: "New Password",
    field: "password",
    type: "text",
    className: "col-12",
    eyeIcon: true
  },
  {
    title: "Confirm New Password",
    field: "confirm_password",
    type: "text",
    className: "col-12",
    eyeIcon: true
  },
];
